import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import axios from "axios";
import apiClient from "../../utils/api";

function PermissionsList () {
   const deletbutton1=()=> {
        const Row1 = document.getElementById('row1')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
  const deletbutton2=()=>{
        const Row1 = document.getElementById('row2')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton3=()=> {
        const Row1 = document.getElementById('row3')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton4=()=> {
        const Row1 = document.getElementById('row4')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
  const deletbutton5=() =>{
        const Row1 = document.getElementById('row5')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
  const deletbutton6=()=> {
        const Row1 = document.getElementById('row6')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton7=()=> {
        const Row1 = document.getElementById('row7')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton8=()=> {
        const Row1 = document.getElementById('row8')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton9=()=> {
        const Row1 = document.getElementById('row9')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton10=()=> {
        const Row1 = document.getElementById('row10')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton11=()=> {
        const Row1 = document.getElementById('row11')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }
   const deletbutton12=()=> {
        const Row1 = document.getElementById('row12')
        if (Row1) {
            Row1.setAttribute("style", "display:none");
        }
    }

    const [roles, setRoles] = useState([]);

    const fetchRoles = async (page = 1) => {
        try {
            const response = await apiClient.get('admin/roles');
            setRoles(response.data.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    return (
            <div className="body d-flex py-3">
                <div className="container-xxl">
                    <PageHeader1 pagetitle='Roles List' righttitle='Add Blog' link='/blogs-add' routebutton={true} />
                    <div className="row g-3 mb-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div id="myDataTable_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className='table-responsive'>
                                                    <table id="myDataTable" className="table table-hover align-middle mb-0 nowrap dataTable no-footer dtr-inline" style={{ width: '100%' }} role="grid" aria-describedby="myDataTable_info">
                                                        <thead>
                                                        <tr role="row">
                                                            <th className="sorting_asc" tabIndex="0"
                                                                aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                                style={{width: '32.2px'}}
                                                                aria-label="Id: activate to sort column descending"
                                                                aria-sort="ascending">Id
                                                            </th>
                                                            <th className="sorting" tabIndex="0"
                                                                aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                                style={{width: '117.2px'}}
                                                                aria-label="Categorie: activate to sort column ascending">Name
                                                            </th>

                                                            <th className="dt-body-right sorting" tabIndex="0"
                                                                aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                                style={{width: '75.2px'}}
                                                                aria-label="Action: activate to sort column ascending">Action
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {roles.map((role, index) => (
                                                            <tr id={index} role="row"
                                                                className={index % 2 === 0 ? 'odd' : 'even'}>
                                                            <td className="sorting_1" tabIndex="0">#{index+1}</td>
                                                            <td className="sorting_1" tabIndex="0">{role.name}</td>
                                                            <td className=" dt-body-right">
                                                                <div className="btn-group" role="group"
                                                                     aria-label="Basic outlined example">
                                                                    <Link
                                                                        to="categories-edit"
                                                                        className="btn btn-outline-secondary"><i
                                                                        className="icofont-edit text-success"></i>
                                                                    </Link>
                                                                    <button
                                                                        onClick={() => {deletbutton11()}}
                                                                        type="button"
                                                                        className="btn btn-outline-secondary deleterow">
                                                                        <i className="icofont-ui-delete text-danger"></i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
export default PermissionsList;